import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as ManagePlanActions from 'web-app/react/plans/manage-plan/actions';

const State = Record({
    loadingBookings: List(),
});

export default handleActions(
    {
        [ManagePlanActions.toggleFundable.type]: (state, {payload}) => {
            return state.merge({
                loadingBookings: state.loadingBookings.push(payload.bookingId),
            });
        },
        // Update the weekdays with the session bookings updated with the new funded minutes
        [ManagePlanActions.previewPlanSuccess.type]: state =>
            state.merge({
                loadingBookings: List(),
            }),
        [ManagePlanActions.previewPlanFailed.type]: state =>
            state.merge({
                loadingBookings: List(),
            }),
        [ManagePlanActions.closeManagePlan.type]: () => new State(),
    },
    new State(),
);
